import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import styled from 'styled-components';


export const STabs = styled(Tabs)`
    font-family: BlinkMacSystemFont, 'Segoe UI', sans-serif;
    border: none;
    outline: none;
    background-color: rgba(98, 147, 97, 1);
    //padding:10px;
    border-radius: 10px;
    font-size: 12px;
    width: 100%;
`;

export const STabList = styled(TabList)`
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    background-color: #7cbe7b;
    border-radius: 5px;

    padding: 4px;
    margin: 0 0 18px;
`;

// STabList.tabsRole = 'TabList';

export const STab = styled(Tab)`
    border: none;
    color: rgba(64, 64, 64, 1);
    padding: 4px 23px;
    font-size: 14px;
    user-select: none;
    cursor: pointer;

    &.is-selected {
        // color: white;
        background: white;
        border-radius: 5px;
        border-bottom: 1px solid white;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 0, 255, 0.5);
    }
`;

// STab.tabsRole = 'Tab';

export const STabPanel = styled(TabPanel)`
    display: none;
    min-height: 40vh;
    padding: 4px;
    margin-top: -5px;

    &.is-selected {
        display: block;
    }
`;

// STabPanel.tabsRole = 'TabPanel';


